export default __webpack_public_path__ + "static/media/project-up-next-app.e8874b6d.png";